updateFileInputs();

$(function() {
	$('a.popup').click(function(e) {
		e.preventDefault();

		width  = $(this).data('popup-width')  || 800;
		height = $(this).data('popup-height') || 600;

		popup($(this).attr('href'), width, height);
	});

	$(document).on('click', '.confirm', function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		showConfirm({
			text:      $(this).data('confirm'),
			textYes:   $(this).data('text-yes'),
			textNo:    $(this).data('text-no'),
			urlYes:    $(this).attr('href'),
			onConfirm: $(this).data('onconfirm'),
		});
	});

	$(document).on('click', 'a.show-alert', function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		showAlert($(this).data('alert'));
	});

	$('#warning').fadeIn('slow');

	$('body').tooltip({
		selector: '[data-bs-toggle="tooltip"], i[title], a[title], abbr[title], div[title], span:not(.element-info-icon)[title]',
		offset: "0, 5",
		delay: 300
	});

	$('.dropdown-toggle').on('click', function(e) {
		if ($(this).attr('href') === '#') {
			e.preventDefault();
		}
	});

	$('.toggle-pass').on('mousedown', function(e) {
		e.preventDefault();

		var $passField = $(this).parent().find('input');
		var $icon      = $(this).find('i');
		var newType    = $passField.attr('type') === 'text' ? 'password' : 'text';

		$passField.attr('type', newType).focus();
		newType === 'text' ? $icon.addClass('fa-eye-slash') : $icon.removeClass('fa-eye-slash');
	}).on('click', function(e) {
		e.preventDefault();
	});

	$('.search-form').each(function() {
		var $form = $(this).closest('form');

		$form.on('click', '.search-add-row', function(e) {
			e.preventDefault();

			var $table  = $(this).closest('table');
			var $row    = $(this).closest('tr');
			var $newRow = $row.clone();

			$newRow.find('input, select').val('');
			$newRow.appendTo($table);
		});

		$form.find('.search-reset').on('click', function() {
			$form.find('input[name=page]').val('1');
			$form.find('input[name=search_reset]').val('1');
			$form.find('input[type=text], select').val('');
			$form.find('input[type=checkbox], input[type=radio]').prop('checked', false);
			$form.trigger('submit');
		});
	});
	
	// Disable submit buttons after submitting
	//$('form').submit(function() {
		//$(':submit').attr('disabled', true);
		//$(':submit').fadeTo('normal', 0.5);
	//});
});

$(function() {
	var $menu        = $('.navbar-mainmenu').first();
	var $menuBody    = $menu.find('.navbar-mainmenu-body');
	var $scrollLeft  = $menu.find('.scroll-left');
	var $scrollRight = $menu.find('.scroll-right');

	function checkScrollBtns() {
		if ($menuBody.length === 0) {
			return;
		}

		var width       = $menuBody.width();
		var scrollWidth = $menuBody.get(0).scrollWidth;
		var scrollLeft  = Math.ceil($menuBody.get(0).scrollLeft);

		$scrollRight.toggleClass('show', width + scrollLeft < scrollWidth);
		$scrollLeft.toggleClass('show', scrollLeft > 0);
	}

	function scrollMenu(offset) {
		$menuBody.stop(false, false).animate({
			scrollLeft: $menuBody.get(0).scrollLeft + offset
		}, 300, function() {
			checkScrollBtns();
		});
	}

	$(window).on('resize init', function() {
		checkScrollBtns();
	}).trigger('init');

	$menu.on('mousewheel scroll touchmove', function() {
		checkScrollBtns();
	});

	$menu.on('touchend', function() {
		setTimeout(checkScrollBtns, 500);
	});

	$scrollLeft.on('click', function() {
		scrollMenu(-200);
	});

	$scrollRight.on('click', function() {
		scrollMenu(200);
	});
})


setInterval("keepAlive('lib/keepalive.php')", 5 * 60 * 1000);
